import { sleep } from "effection";
import { call, createAction, spawn, take } from "starfx";

import { runThunk } from "@app/statefx/helpers/fxhelpers";
import { wClearCache } from "@app/statefx/xThunks/ds";
import { sfxNotify } from "@app/statefx/xThunks/notify";
import { invoiceActionFromDelphi } from "@app/statefx/xThunks/uiInvoiceOverall";
import { svpReceivingSpvMessage } from "@app/statefx/xThunks/uiSpvMain";

import type { ActionWithPayload } from "starfx";
/* 
  the delphi code:
  json := CkJsonObject_Create();
  try
    CkJsonObject_AddStringAt(json, -1, 'type', msgType);
    CkJsonObject_AddStringAt(json, -1, 'message', msg);
    CkJsonObject_AddIntAt(json, -1, 'duration', duration);
    jsonStr := CkJsonObject__emit(json);
    frmCentral.Chromium1.ExecuteJavaScript(
      UTF8Encode('fx.dispatch({type:"@@delphi/notification", payload: ' + jsonStr + '});'),
      browserRoot);
  finally
    CkJsonObject_Dispose(json);
  end;

*/
type TNotification = {
  type: "info" | "error" | "warning" | "success";
  message: string;
  duration: number;
};

export function* receiveStdoutFromDelphi() {
  function* doNotify(psi) {
    const { type, message, duration } = psi.payload;
    yield* runThunk(sfxNotify, {
      message: message,
      type: type,
      duration: duration,
      position: "bottom",
    });
  }

  while (true) {
    const u = (yield* take(
      "@@delphi/notification"
    )) as ActionWithPayload<TNotification>;
    if (u.payload) {
      yield* spawn(() => doNotify(u));
    }
  }
}

export function* receiveSpvMessageFromDelphi() {
  function* spvMsg(pi) {
    yield* runThunk(svpReceivingSpvMessage, pi.payload);
  }
  while (true) {
    const u = (yield* take("@@delphi/spvmsg")) as ActionWithPayload<string>;
    yield* spawn(() => spvMsg(u));
  }
}

export function* invoiceActionsFromDelphi() {
  function* doInvoice(xsi) {
    yield* runThunk(invoiceActionFromDelphi, xsi.payload);
    yield* sleep(0);
  }
  while (true) {
    const u = (yield* take("@@delphi/invoice")) as ActionWithPayload<string>;
    yield* spawn(() => doInvoice(u));
  }
}

export function* resetIndexedDB() {
  while (true) {
    const u = (yield* take(
      "!!root-saga/clearHashes"
    )) as ActionWithPayload<boolean>;
    if (u.payload) {
      yield* call(wClearCache.run());
    }
  }
}

export function* waitForMamba() {
  while (true) {
    const u = (yield* take("mamba")) as ActionWithPayload<boolean>;
    console.log("WE GOT MAMBA", u);
    if (u.payload) {
      yield* sleep(0);
    }
  }
}
